import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';

@Component({
  selector: 'app-load-event-cancel-checkin',
  templateUrl: './load-event-cancel-checkin.component.html',
  styleUrls: ['./load-event-cancel-checkin.component.scss']
})
export class LoadEventCancelCheckinComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor() {
  }

  ngOnInit() {
  }
}
